import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { Capability } from '../../../models/employee/Capability';
import { EmployeeCapabilityResponse } from '../../../../interfaces/response/EmployeeResponse';

/**
 * An adapter converts capability HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class CapabilityAdapter implements Adapter<Capability[]> {

  /**
   * Converts capability HTTP response to a list of {@link Capability}.
   * @param item capability HTTP response.
   */
  adapt(item: EmployeeCapabilityResponse[]): Capability[] {
    if (!item) {
      return [];
    }
    const result: Capability[] = [];
    item.forEach($item => result.push(new Capability($item.capabilities, $item.date)));
    return result.sort((previous, current) => current.startDate < previous.startDate ? 1 : -1);
  }
}
